<template>
  <div class="flex items-center justify-center gap-3 px-4 rounded-full bg-white h-12 !shadow">
    <div class="rounded-full bg-sky-600 py-1 px-3 uppercase font-bold text-white"
      v-if="currentIndex === schedules.length - 1">
      Current
    </div>
    <div class="rounded-full bg-slate-400 py-1 px-3 uppercase font-bold text-white"
      v-if="currentIndex !== schedules.length - 1"
      style="background-color: rgb(46, 55, 71);">
      Past
    </div>
    <div class="flex items-center gap-1 text-lg">
      <div>{{ startDate }}</div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-6 w-6"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        stroke-width="2">
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M18 12H6"
        />
      </svg>
      <div>{{ endDate }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    schedules: {
      type: Array,
      default: undefined,
    },
    currentIndex: undefined,
  },
  data() {
    return {}
  },
  computed: {
    startDate() {
      if (this.schedules[this.currentIndex]?.startDate) {
        return new Date(this.schedules[this.currentIndex].startDate).toLocaleString(
          'en-US',
          {
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
            timeZone: 'UTC',
          }
        )
      } else {
        return ''
      }
    },
    endDate() {
      if (this.schedules[this.currentIndex]?.endDate) {
        let endDateExclusive = new Date(this.schedules[this.currentIndex].endDate)
        let endDateDisplay = new Date(endDateExclusive.getTime())
        endDateDisplay.setDate(endDateExclusive.getDate() - 1)
        return endDateDisplay.toLocaleString('en-US', {
          year: 'numeric',
          month: 'numeric',
          day: 'numeric',
          timeZone: 'UTC',
        })
      } else {
        return 'Present'
      }
    },
  }
}
</script>
